import React from "react";
import Navbar from "../../components/navbar/Navbar";
import Integration from "../../components/dashboard/integrations/Integration";
import Overview from "../../components/dashboard/overview/Overview";
import TargetRealisasi5Tahun from "../../components/dashboard/target_realisasi_5_tahun/TargetRealisasi5Tahun";
import TargetRealisasi from "../../components/dashboard/target_realisasi/TargetRealisasi";
import Piutang from "../../components/dashboard/akumulasi_piutang/Piutang";
import RealisasiBulanan from "../../components/dashboard/realisasi_bulanan/RealisasiBulanan";
import PendapatanWajibBayar from "../../components/dashboard/pendapatan_wajib_bayar/PendapatanWajibBayar";
import RincianPiutang from "../../components/dashboard/rincian_piutang/RincianPiutang";
import Login from "../Login";

import axios from "axios";
import CryptoJS from "crypto-js";

const AuthUser = () => {
  // check token on local storage
  if (localStorage.getItem("authorized")) {
    // TDOO validasi token
    return <Dashboard />;
  } else {
    return <Login />;
  }
};

const Dashboard = () => {
  const thisYear = new Date().getFullYear();
  const tahunBukuBerjalan = thisYear - 1;
  const thisDate = new Date().toISOString().split("T")[0];
  const lastDateYearBefore = thisYear - 1 + "-12-31";

  const katalogEPNBP = axios.create({
    baseURL: process.env.REACT_APP_URL_API_KATALOG_EPNBP,
  });

  const katalogKerjasamaBU = axios.create({
    baseURL: process.env.REACT_APP_URL_API_KATALOG_KERJASAMABU,
  });

  const katalogJasaPerbankan = axios.create({
    baseURL: process.env.REACT_APP_URL_API_KATALOG_JASAPERBANKAN,
  });

  const katalogPendapatanLainlain = axios.create({
    baseURL: process.env.REACT_APP_URL_API_KATALOG_PENDAPATANLAINLAIN,
  });

  // Kumpulan variabel tahun untuk selector pada masing masing komponen yang memerlukan
  const [tahunTargetRealisasiTahunan, setTahunTargetRealisasiTahunan] =
    React.useState(thisYear);
  const [tahunPiutangJenisPendapatan, setTahunPiutangJenisPendapatan] =
    React.useState(thisYear);
  const [tahunRealisasiBulanan, setTahunRealisasiBulanan] =
    React.useState(thisYear);
  const [tahunRincianPiutang, setTahunRincianPiutang] =
    React.useState(thisYear);
  const [tahunPendapatanWajibBayar, setTahunPendapatanWajibBayar] =
    React.useState(tahunBukuBerjalan);

  const [targetEPNBP, setTargetEPNBP] = React.useState([]);
  const [targetKerjasamaBU, setTargetKerjasamaBU] = React.useState([]);
  const [targetJasaPerbankan, setTargetJasaPebankan] = React.useState([]);
  const [targetPendapatanLainlain, setTargetPendapatanLainlain] =
    React.useState([]);

  const [target5TahunEPNBP, setTarget5TahunEPNBP] = React.useState([]);
  const [target5TahunKerjasamaBU, setTarget5TahunKerjasamaBU] = React.useState(
    []
  );
  const [target5TahunJasaPerbankan, setTarget5TahunJasaPerbankan] =
    React.useState([]);
  const [target5TahunPendapatanLainlain, setTarget5TahunPendapatanLainlain] =
    React.useState([]);

  const [realisasiTahunanEPNBP, setRealisasiTahunanEPNBP] = React.useState([]);
  const [realisasiTahunanKerjasamaBU, setRealisasiTahunanKerjasamaBU] =
    React.useState([]);
  const [realisasiTahunanJasaPerbankan, setRealisasiTahunanJasaPerbankan] =
    React.useState([]);
  const [
    realisasiTahunanPendapatanLainlain,
    setRealisasiTahunanPendapatanLainlain,
  ] = React.useState([]);

  const [realisasiBulananEPNBP, setRealisasiBulananEPNBP] = React.useState([]);
  const [realisasiBulananKerjasamaBU, setRealisasiBulananKerjasamaBU] =
    React.useState([]);
  const [realisasiBulananJasaPerbankan, setRealisasiBulananJasaPerbankan] =
    React.useState([]);
  const [
    realisasiBulananPendapatanLainlain,
    setRealisasiBulananPendapatanLainlain,
  ] = React.useState([]);

  const [realisasi5TahunEPNBP, setRealisasi5TahunEPNBP] = React.useState([]);
  const [realisasi5TahunKerjasamaBU, setRealisasi5TahunKerjasamaBU] =
    React.useState([]);
  const [realisasi5TahunJasaPerbankan, setRealisasi5TahunJasaPerbankan] =
    React.useState([]);
  const [
    realisasi5TahunPendapatanLainlain,
    setRealisasi5TahunPendapatanLainlain,
  ] = React.useState([]);

  const [akumulasiPiutangEPNBP, setAkumulasiPiutangEPNBP] = React.useState([]);
  const [akumulasiPiutangKerjasamaBU, setAkumulasiPiutangKerjasamaBU] =
    React.useState([]);
  const [
    akumulasiPiutangPendapatanLainlain,
    setAkumulasiPiutangPendapatanLainlain,
  ] = React.useState([]);

  const [
    akumulasiTahunSebelumnyaPiutangEPNBP,
    setAkumulasiTahunSebelumnyaPiutangEPNBP,
  ] = React.useState([]);
  const [
    akumulasiTahunSebelumnyaPiutangKerjasamaBU,
    setAkumulasiTahunSebelumnyaPiutangKerjasamaBU,
  ] = React.useState([]);
  const [
    akumulasiTahunSebelumnyaPiutangPendapatanLainlain,
    setAkumulasiTahunSebelumnyaPiutangPendapatanLainlain,
  ] = React.useState([]);

  const [akumulasiPiutangWidget, setAkumulasiPiutangWidget] = React.useState(0);
  const [
    akumulasiTahunSebelumnyaPiutangWidget,
    setAkumulasiTahunSebelumnyaPiutangWidget,
  ] = React.useState(0);

  const [rincianPiutangEPNBP, setRincianPiutangEPNBP] = React.useState([]);
  const [rincianPiutangKerjasamaBU, setRincianPiutangKerjasamaBU] =
    React.useState([]);
  const [
    rincianPiutangPendapatanLainlain,
    setRincianPiutangPendapatanLainlain,
  ] = React.useState([]);

  const [pendapatanKotorWajibBayar, setPendapatanKotorWajibBayar] =
    React.useState([]);

  const getRealisasiTahunan = async (tahun) => {
    const responseEPNBP = await katalogEPNBP.get(
      "/realisasi?tahun=" + tahun + "&jenis_pendapatan=1",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_EPNBP + "/realisasi",
            "epnbp"
          ),
        },
      }
    );
    const responseKerjasamaBU = await katalogKerjasamaBU.get(
      "/realisasi?tahun=" + tahun + "&jenis_pendapatan=2",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_KERJASAMABU + "/realisasi",
            "kerjasamabu"
          ),
        },
      }
    );
    const responseJasaPerbankan = await katalogJasaPerbankan.get(
      "/realisasi?tahun=" + tahun + "&jenis_pendapatan=3",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_JASAPERBANKAN + "/realisasi",
            "jasaperbankan"
          ),
        },
      }
    );
    const responsePendapatanLainlain = await katalogJasaPerbankan.get(
      "/realisasi?tahun=" + tahun + "&jenis_pendapatan=4",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_JASAPERBANKAN + "/realisasi",
            "jasaperbankan"
          ),
        },
      }
    );

    if (responseEPNBP.status === 200) {
      setRealisasiTahunanEPNBP(responseEPNBP.data);
    }
    if (responseKerjasamaBU.status === 200) {
      setRealisasiTahunanKerjasamaBU(responseKerjasamaBU.data);
    }
    if (responseJasaPerbankan.status === 200) {
      setRealisasiTahunanJasaPerbankan(responseJasaPerbankan.data);
    }
    if (responsePendapatanLainlain.status === 200) {
      setRealisasiTahunanPendapatanLainlain(responsePendapatanLainlain.data);
    }
  };

  const getRealisasi5Tahun = async () => {
    const responseEPNBP = await katalogEPNBP.get(
      "/realisasi_5tahun?tahun=4&jenis_pendapatan=1",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_EPNBP + "/realisasi_5tahun",
            "epnbp"
          ),
        },
      }
    );
    const responseKerjasamaBU = await katalogKerjasamaBU.get(
      "/realisasi_5tahun?tahun=4&jenis_pendapatan=2",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_KERJASAMABU +
              "/realisasi_5tahun",
            "kerjasamabu"
          ),
        },
      }
    );
    const responseJasaPerbankan = await katalogJasaPerbankan.get(
      "/realisasi_5tahun?tahun=" + thisYear + "&jenis_pendapatan=3",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_JASAPERBANKAN +
              "/realisasi_5tahun",
            "jasaperbankan"
          ),
        },
      }
    );
    const responsePendapatanLainlain = await katalogJasaPerbankan.get(
      "/realisasi_5tahun?tahun=" + thisYear + "&jenis_pendapatan=4",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_JASAPERBANKAN +
              "/realisasi_5tahun",
            "jasaperbankan"
          ),
        },
      }
    );

    if (responseEPNBP.status === 200) {
      setRealisasi5TahunEPNBP(responseEPNBP.data);
    }
    if (responseKerjasamaBU.status === 200) {
      setRealisasi5TahunKerjasamaBU(responseKerjasamaBU.data);
    }
    if (responseJasaPerbankan.status === 200) {
      setRealisasi5TahunJasaPerbankan(responseJasaPerbankan.data);
    }
    if (responsePendapatanLainlain.status === 200) {
      setRealisasi5TahunPendapatanLainlain(responsePendapatanLainlain.data);
    }
  };

  const getTargetTahunan = async (tahun) => {
    const responseEPNBP = await katalogEPNBP.get("/target?tahun=" + tahun, {
      headers: {
        Accept: "application/json",
        signature: getAuthHeader(
          process.env.REACT_APP_URL_API_KATALOG_EPNBP + "/target",
          "epnbp"
        ),
      },
    });
    const responseKerjasamaBU = await katalogKerjasamaBU.get(
      "/target?tahun=" + tahun,
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_KERJASAMABU + "/target",
            "kerjasamabu"
          ),
        },
      }
    );
    const responseJasaPerbankan = await katalogJasaPerbankan.get(
      "/target?tahun=" + tahun,
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_JASAPERBANKAN + "/target",
            "jasaperbankan"
          ),
        },
      }
    );
    const responsePendapatanLainlain = 0;

    if (responseEPNBP.status === 200) {
      setTargetEPNBP(responseEPNBP.data);
    }
    if (responseKerjasamaBU.status === 200) {
      setTargetKerjasamaBU(responseKerjasamaBU.data);
    }
    if (responseJasaPerbankan.status === 200) {
      setTargetJasaPebankan(responseJasaPerbankan.data);
    }
    setTargetPendapatanLainlain({ nominal_target: 0, jenis_pendapatan: 4 });
  };

  const getTarget5Tahun = async () => {
    const responseEPNBP = await katalogEPNBP.get("/target_5tahun?tahun=4", {
      headers: {
        Accept: "application/json",
        signature: getAuthHeader(
          process.env.REACT_APP_URL_API_KATALOG_EPNBP + "/target_5tahun",
          "epnbp"
        ),
      },
    });
    const responseKerjasamaBU = await katalogKerjasamaBU.get(
      "/target_5tahun?tahun=4",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_KERJASAMABU +
              "/target_5tahun",
            "kerjasamabu"
          ),
        },
      }
    );
    const responseJasaPerbankan = await katalogJasaPerbankan.get(
      "/target_5tahun?tahun=" + thisYear,
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_JASAPERBANKAN +
              "/target_5tahun",
            "jasaperbankan"
          ),
        },
      }
    );

    if (responseEPNBP.status === 200) {
      setTarget5TahunEPNBP(responseEPNBP.data);
    }
    if (responseKerjasamaBU.status === 200) {
      setTarget5TahunKerjasamaBU(responseKerjasamaBU.data);
    }
    if (responseJasaPerbankan.status === 200) {
      setTarget5TahunJasaPerbankan(responseJasaPerbankan.data);
    }

    // Assign Manual Untuk Target 5 Tahun Pendapatan Lain Lain;
    let startYear = thisYear - 4;
    let responsePendapatanLainlain = {};
    for (startYear; startYear <= thisYear; startYear++) {
      responsePendapatanLainlain[startYear] = 0;
    }
    setTarget5TahunPendapatanLainlain(responsePendapatanLainlain);
  };

  const getAkumulasiPiutang = async (tahun, setAkumulasi = false) => {
    let tanggalcutoff;
    if (tahun === thisYear) {
      tanggalcutoff = thisDate;
    } else {
      tanggalcutoff = tahun + "-12-31";
    }

    const responseEPNBP = await katalogEPNBP.get(
      "/akumulasi_piutang?tanggal_cut_off=" +
        tanggalcutoff +
        "&jenis_pendapatan=1",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_EPNBP + "/akumulasi_piutang",
            "epnbp"
          ),
        },
      }
    );
    const responseKerjasamaBU = await katalogKerjasamaBU.get(
      "/akumulasi_piutang?tanggal_cut_off=" +
        tanggalcutoff +
        "&jenis_pendapatan=2",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_KERJASAMABU +
              "/akumulasi_piutang",
            "kerjasamabu"
          ),
        },
      }
    );
    const responsePendapatanLainlain = await katalogKerjasamaBU.get(
      "/akumulasi_piutang?tanggal_cut_off=" +
        tanggalcutoff +
        "&jenis_pendapatan=4",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_KERJASAMABU +
              "/akumulasi_piutang",
            "kerjasamabu"
          ),
        },
      }
    );

    if (responseEPNBP.status === 200) {
      setAkumulasiPiutangEPNBP(responseEPNBP.data);
    }
    if (responseKerjasamaBU.status === 200) {
      setAkumulasiPiutangKerjasamaBU(responseKerjasamaBU.data);
    }
    if (responsePendapatanLainlain.status === 200) {
      setAkumulasiPiutangPendapatanLainlain(responsePendapatanLainlain.data);
    }

    if (setAkumulasi === true) {
      setAkumulasiPiutangWidget(
        responseEPNBP.data.nominal_piutang +
          responseKerjasamaBU.data.nominal_piutang +
          responsePendapatanLainlain.data.nominal_piutang
      );
    }
  };

  const getAkumulasiPiutangTahunSebelumnya = async (setAkumulasi = false) => {
    const responseTahunSebelumnyaEPNBP = await katalogEPNBP.get(
      "/akumulasi_piutang?tanggal_cut_off=" +
        lastDateYearBefore +
        "&jenis_pendapatan=1",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_EPNBP + "/akumulasi_piutang",
            "epnbp"
          ),
        },
      }
    );
    const responseTahunSebelumnyaKerjasamaBU = await katalogKerjasamaBU.get(
      "/akumulasi_piutang?tanggal_cut_off=" +
        lastDateYearBefore +
        "&jenis_pendapatan=2",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_KERJASAMABU +
              "/akumulasi_piutang",
            "kerjasamabu"
          ),
        },
      }
    );
    const responseTahunSebelumnyaPendapatanLainlain =
      await katalogKerjasamaBU.get(
        "/akumulasi_piutang?tanggal_cut_off=" +
          lastDateYearBefore +
          "&jenis_pendapatan=4",
        {
          headers: {
            Accept: "application/json",
            signature: getAuthHeader(
              process.env.REACT_APP_URL_API_KATALOG_KERJASAMABU +
                "/akumulasi_piutang",
              "kerjasamabu"
            ),
          },
        }
      );

    if (responseTahunSebelumnyaEPNBP.status === 200) {
      setAkumulasiTahunSebelumnyaPiutangEPNBP(
        responseTahunSebelumnyaEPNBP.data
      );
    }
    if (responseTahunSebelumnyaKerjasamaBU.status === 200) {
      setAkumulasiTahunSebelumnyaPiutangKerjasamaBU(
        responseTahunSebelumnyaKerjasamaBU.data
      );
    }
    if (responseTahunSebelumnyaPendapatanLainlain.status === 200) {
      setAkumulasiTahunSebelumnyaPiutangPendapatanLainlain(
        responseTahunSebelumnyaPendapatanLainlain.data
      );
    }

    if (setAkumulasi === true) {
      setAkumulasiTahunSebelumnyaPiutangWidget(
        responseTahunSebelumnyaEPNBP.data.nominal_piutang +
          responseTahunSebelumnyaKerjasamaBU.data.nominal_piutang +
          responseTahunSebelumnyaPendapatanLainlain.data.nominal_piutang
      );
    }
  };

  const getRealisasiBulanan = async (tahun) => {
    const responseEPNBP = await katalogEPNBP.get(
      "/realisasi_bulanan?tahun=" + tahun + "&jenis_pendapatan=1",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_EPNBP + "/realisasi_bulanan",
            "epnbp"
          ),
        },
      }
    );
    const responseKerjasamaBU = await katalogKerjasamaBU.get(
      "/realisasi_bulanan?tahun=" + tahun + "&jenis_pendapatan=2",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_EPNBP + "/realisasi_bulanan",
            "kerjasamabu"
          ),
        },
      }
    );
    const responseJasaPerbankan = await katalogJasaPerbankan.get(
      "/realisasi_bulanan?tahun=" + tahun + "&jenis_pendapatan=3",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_JASAPERBANKAN +
              "/realisasi_bulanan",
            "jasaperbankan"
          ),
        },
      }
    );
    const responsePendapatanLainlain = await katalogJasaPerbankan.get(
      "/realisasi_bulanan?tahun=" + tahun + "&jenis_pendapatan=4",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_JASAPERBANKAN +
              "/realisasi_bulanan",
            "jasaperbankan"
          ),
        },
      }
    );
    if (responseEPNBP.status === 200) {
      setRealisasiBulananEPNBP(responseEPNBP.data);
    }
    if (responseKerjasamaBU.status === 200) {
      setRealisasiBulananKerjasamaBU(responseKerjasamaBU.data);
    }
    if (responseJasaPerbankan.status === 200) {
      setRealisasiBulananJasaPerbankan(responseJasaPerbankan.data);
    }
    if (responsePendapatanLainlain.status === 200) {
      setRealisasiBulananPendapatanLainlain(responsePendapatanLainlain.data);
    }
  };

  const getRincianPiutang = async (tahun) => {
    let tanggalcutoff;
    if (parseInt(tahun) === thisYear) {
      tanggalcutoff = thisDate;
    } else {
      tanggalcutoff = tahun + "-12-31";
    }

    const responseEPNBP = await katalogEPNBP.get(
      "data_piutang?tanggal_cut_off=" +
        tanggalcutoff +
        "&limit=20&jenis_pendapatan=1",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_EPNBP + "/data_piutang",
            "epnbp"
          ),
        },
      }
    );
    const responseKerjasamaBU = await katalogKerjasamaBU.get(
      "data_piutang?tanggal_cut_off=" +
        tanggalcutoff +
        "&limit=20&jenis_pendapatan=2",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_KERJASAMABU + "/data_piutang",
            "kerjasamabu"
          ),
        },
      }
    );
    const responsePendapatanLainlain = await katalogPendapatanLainlain.get(
      "data_piutang?tanggal_cut_off=" +
        tanggalcutoff +
        "&limit=20&jenis_pendapatan=4",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_PENDAPATANLAINLAIN +
              "/data_piutang",
            "pendapatanlainlain"
          ),
        },
      }
    );

    if (responseEPNBP.status === 200) {
      setRincianPiutangEPNBP(responseEPNBP.data);
    }
    if (responseKerjasamaBU.status === 200) {
      setRincianPiutangKerjasamaBU(responseKerjasamaBU.data);
    }
    if (responsePendapatanLainlain.status === 200) {
      setRincianPiutangPendapatanLainlain(responsePendapatanLainlain.data);
    }
  };

  const getPendapatanKotorWajibBayar = async (tahunBuku) => {
    const responseEPNBP = await katalogEPNBP.get(
      "/pendapatan_kotor?tahun=" + tahunBuku + "&limit=20",
      {
        headers: {
          Accept: "application/json",
          signature: getAuthHeader(
            process.env.REACT_APP_URL_API_KATALOG_EPNBP + "/pendapatan_kotor",
            "epnbp"
          ),
        },
      }
    );

    if (responseEPNBP.status === 200) {
      setPendapatanKotorWajibBayar(responseEPNBP.data);
    }
  };

  //increase counter
  const increase = () => {
    setTahunTargetRealisasiTahunan((tahun) => tahun + 1);
  };

  //decrease counter
  const decrease = () => {
    if (tahunTargetRealisasiTahunan > 2018) {
      setTahunTargetRealisasiTahunan((tahun) => tahun - 1);
    }
  };

  // Use Effect Untuk Realisasi dan Target 5 Tahun
  React.useEffect(() => {
    getRealisasiTahunan(thisYear);
    getTargetTahunan(thisYear);
    getRealisasi5Tahun();
    getTarget5Tahun();
    getAkumulasiPiutang(thisYear, true);
    getAkumulasiPiutangTahunSebelumnya(true);
    getRealisasiBulanan(thisYear);
    getRincianPiutang(thisYear);
    getPendapatanKotorWajibBayar(tahunBukuBerjalan);
  }, []);

  // Use Effect Untuk Realisasi dan Target Tahunan
  React.useEffect(() => {
    getRealisasiTahunan(tahunTargetRealisasiTahunan);
    getTargetTahunan(tahunTargetRealisasiTahunan);
  }, [tahunTargetRealisasiTahunan]);

  // Use Effect Untuk Piutang Pendapatan Sesuai Jenis Tagihan
  React.useEffect(() => {
    getAkumulasiPiutang(tahunPiutangJenisPendapatan);
  }, [tahunPiutangJenisPendapatan]);

  // Use Effect Untuk Realisasi Bulanan
  React.useEffect(() => {
    getRealisasiBulanan(tahunRealisasiBulanan);
  }, [tahunRealisasiBulanan]);

  // Use Effect Nilai Piutang Terbesar
  React.useEffect(() => {
    getRincianPiutang(tahunRincianPiutang);
  }, [tahunRincianPiutang]);

  // Use Effect Pendapatan Kotor Terbesar
  React.useEffect(() => {
    getPendapatanKotorWajibBayar(tahunPendapatanWajibBayar);
  }, [tahunPendapatanWajibBayar]);

  return (
    <div id="dashboard" className="bg-gray-light">
      <div id="header">
        <Navbar appName={"Dashboard Pendapatan BAKTI"} url={"/"} />
      </div>
      <div id="content">
        <div
          id="integration"
          className="bg-primary-second px-8 md:px-16 w-full py-6 bg-integration-decoration bg-repeat-x"
        >
          <div className="container mx-auto">
            <h3 className="text-xl md:text-2xl font-bold mb-6 text-white">
              Integrations
            </h3>
            <Integration />
          </div>
        </div>
        <div id="overview" className="pt-6 px-8 md:px-16 w-full">
          <div className="container mx-auto">
            <h3 className="text-xl md:text-2xl text-black font-bold mb-6">
              Overview
            </h3>
            <Overview
              nominalpendapatan={
                realisasi5TahunEPNBP[thisYear] +
                realisasi5TahunKerjasamaBU[thisYear] +
                realisasi5TahunJasaPerbankan[thisYear] +
                realisasi5TahunPendapatanLainlain[thisYear]
              }
              nominalpendapatansebelumnya={
                realisasi5TahunEPNBP[thisYear - 1] +
                realisasi5TahunKerjasamaBU[thisYear - 1] +
                realisasi5TahunJasaPerbankan[thisYear - 1] +
                realisasi5TahunPendapatanLainlain[thisYear - 1]
              }
              nominalpiutang={akumulasiPiutangWidget}
              nominalpiutangsebelumnya={akumulasiTahunSebelumnyaPiutangWidget}
            />
          </div>
        </div>
        <div
          id="target-realisasi-5-tahun"
          className="pt-6 px-8 md:px-16 w-full"
        >
          <div className="container mx-auto">
            <TargetRealisasi5Tahun
              epnbp={realisasi5TahunEPNBP}
              kerjasamabu={realisasi5TahunKerjasamaBU}
              jasaperbankan={realisasi5TahunJasaPerbankan}
              pendapatanlainlain={realisasi5TahunPendapatanLainlain}
              targetepnbp={target5TahunEPNBP}
              targetkerjasamabu={target5TahunKerjasamaBU}
              targetjasaperbankan={target5TahunJasaPerbankan}
              targetpendapatanlainlain={target5TahunPendapatanLainlain}
            />
          </div>
        </div>
        <div
          id="realisasi-tahunan-dan-piutang"
          className="pt-6 px-8 md:px-16 w-full"
        >
          <div className="container mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="w-full rounded-lg border border-neutral-300 bg-white">
                <TargetRealisasi
                  tahun={tahunTargetRealisasiTahunan}
                  setTahun={setTahunTargetRealisasiTahunan}
                  tambah={increase}
                  kurang={decrease}
                  epnbp={realisasiTahunanEPNBP}
                  kerjasamabu={realisasiTahunanKerjasamaBU}
                  jasaperbankan={realisasiTahunanJasaPerbankan}
                  pendapatanlainlain={realisasiTahunanPendapatanLainlain}
                  targetepnbp={targetEPNBP}
                  targetkerjasamabu={targetKerjasamaBU}
                  targetjasaperbankan={targetJasaPerbankan}
                  targetpendapatanlainlain={targetPendapatanLainlain}
                />
              </div>
              <div className="w-full rounded-lg border border-neutral-300 bg-white">
                <Piutang
                  tahun={tahunPiutangJenisPendapatan}
                  setTahun={setTahunPiutangJenisPendapatan}
                  epnbp={akumulasiPiutangEPNBP}
                  kerjasamabu={akumulasiPiutangKerjasamaBU}
                  pendapatanlainlain={akumulasiPiutangPendapatanLainlain}
                />
              </div>
            </div>
          </div>
        </div>
        <div id="realisasi-bulanan" className="pt-6 px-8 md:px-16 w-full">
          <div className="container mx-auto">
            <div className="grid grid-cols-1">
              <div className="w-full rounded-lg border border-neutral-300 bg-white">
                <RealisasiBulanan
                  tahun={tahunRealisasiBulanan}
                  setTahun={setTahunRealisasiBulanan}
                  epnbp={realisasiBulananEPNBP}
                  kerjasamabu={realisasiBulananKerjasamaBU}
                  jasaperbankan={realisasiBulananJasaPerbankan}
                  pendapatanlainlain={realisasiBulananPendapatanLainlain}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          id="rincian-piutang-dan-pendapatan-wajib-bayar"
          className="pt-6 px-8 md:px-16 w-full"
        >
          <div className="container mx-auto">
            <Tabs
              tahunRincianPiutang={tahunRincianPiutang}
              setTahunRincianPiutang={setTahunRincianPiutang}
              tahunPendapatanWajibBayar={tahunPendapatanWajibBayar}
              setTahunPendapatanWajibBayar={setTahunPendapatanWajibBayar}
              rincianpiutangepnbp={rincianPiutangEPNBP}
              rincianpiutangkerjasamabu={rincianPiutangKerjasamaBU}
              rincianpiutangpendapatanlainlain={
                rincianPiutangPendapatanLainlain
              }
              pendapatanKotorWajibBayar={pendapatanKotorWajibBayar}
            />
          </div>
        </div>
      </div>
      <div id="footer" className="pt-6">
        <footer className="px-8 md:px-16 py-10 bg-white text-secondary-dark font-semibold">
          <div className="container mx-auto">
            <div className="grid grid-cols-2">
              <div className="text-sm md:text-base">
                Copyright &copy; 2023 Divisi Pendapatan Direktorat Keuangan
                BAKTI Kominfo
              </div>
              <div className="text-sm md:text-base text-end">
                Develop by{" "}
                <a
                  href="https://reksa.co.id/"
                  className="underline font-medium"
                  target="_blank"
                  rel="noreferrer"
                >
                  Reksa Karya
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export const Tabs = ({
  tahunRincianPiutang,
  setTahunRincianPiutang,
  tahunPendapatanWajibBayar,
  setTahunPendapatanWajibBayar,
  rincianpiutangepnbp,
  rincianpiutangkerjasamabu,
  rincianpiutangpendapatanlainlain,
  pendapatanKotorWajibBayar,
}) => {
  const [openTab, setOpenTab] = React.useState(1);
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full">
          <ul className="flex mb-0 list-none flex-warp flex-row" role="tablist">
            <li className="-mb-px mr-2 last:mr-0 text-center">
              <a
                className={
                  "text-sm md:text-xl font-semibold px-3 md:px-5 py-3 shadow-lg border border-neutral-300 rounded-t-lg block leading-normal " +
                  (openTab === 1
                    ? "text-white bg-primary-main"
                    : "text-gray-dark bg-white")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(1);
                }}
                data-toggle="tab"
                href="#rincianPiutang"
                role="tablist"
              >
                Nilai Piutang Terbesar
              </a>
            </li>

            <li className="-mb-px mr-2 last:mr-0 text-center">
              <a
                className={
                  "text-sm md:text-xl font-semibold px-3 md:px-5 py-3 shadow-lg border border-neutral-300 rounded-t-lg block leading-normal " +
                  (openTab === 2
                    ? "text-white bg-primary-main"
                    : "text-gray-dark bg-white")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(2);
                }}
                data-toggle="tab"
                href="#rincianPendapatanKotor"
                role="tablist"
              >
                Pendapatan Wajib Bayar Terbesar
              </a>
            </li>
          </ul>

          <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded-b-lg md:rounded-tr-lg border border-neutral-300">
            <div className="px-4 py-4 md:py-10 flex-auto">
              <div className="tab-content tab-space">
                <div
                  className={openTab === 1 ? "block" : "hidden"}
                  id="rincianPiutang"
                >
                  <div className="md:px-8">
                    <RincianPiutang
                      tahun={tahunRincianPiutang}
                      setTahun={setTahunRincianPiutang}
                      rincianpiutangepnbp={rincianpiutangepnbp}
                      rincianpiutangkerjasamabu={rincianpiutangkerjasamabu}
                      rincianpiutangpendapatanlainlain={
                        rincianpiutangpendapatanlainlain
                      }
                    />
                  </div>
                </div>

                <div
                  className={openTab === 2 ? "block" : "hidden"}
                  id="rincianPendapatanKotor"
                >
                  <div className="md:px-8">
                    <PendapatanWajibBayar
                      tahun={tahunPendapatanWajibBayar}
                      setTahun={setTahunPendapatanWajibBayar}
                      pendapatanwajibbayar={pendapatanKotorWajibBayar}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function getAuthHeader(requestUrl, requestApp) {
  let signatureID = null;
  let signatureKey = null;
  let signatureSecret = null;

  switch (requestApp) {
    case "epnbp":
      signatureID = process.env.REACT_APP_SIGNATURE_EPNBP_ID;
      signatureKey = process.env.REACT_APP_SIGNATURE_EPNBP_KEY;
      signatureSecret = process.env.REACT_APP_SIGNATURE_EPNBP_SECRET;
      break;
    case "kerjasamabu":
      signatureID = process.env.REACT_APP_SIGNATURE_KERJASAMABU_ID;
      signatureKey = process.env.REACT_APP_SIGNATURE_KERJASAMABU_KEY;
      signatureSecret = process.env.REACT_APP_SIGNATURE_KERJASAMABU_SECRET;
      break;
    case "jasaperbankan":
      signatureID = process.env.REACT_APP_SIGNATURE_JASAPERBANKAN_ID;
      signatureKey = process.env.REACT_APP_SIGNATURE_JASAPERBANKAN_KEY;
      signatureSecret = process.env.REACT_APP_SIGNATURE_JASAPERBANKAN_SECRET;
      break;
    case "pendapatanlainlain":
      signatureID = process.env.REACT_APP_SIGNATURE_PENDAPATANLAINLAIN_ID;
      signatureKey = process.env.REACT_APP_SIGNATURE_PENDAPATANLAINLAIN_KEY;
      signatureSecret =
        process.env.REACT_APP_SIGNATURE_PENDAPATANLAINLAIN_SECRET;
      break;
    default:
      signatureID = null;
      signatureKey = null;
      signatureSecret = null;
      break;
  }

  const pathRegex = /.+?\:\/\/.+?(\/.+?)(?:#|\?|$)/;
  let result = requestUrl.match(pathRegex);
  let url =
    result && result.length > 1
      ? result[1]
          .replace("kerjasamabu/", "")
          .replace("epnbp/", "")
          .replace("/bank", "")
          .replace("pendapatanlainlain/", "")
      : "";

  const payload = signatureID + ":" + url + ":" + signatureKey;
  const hmacSignature = CryptoJS.HmacSHA256(payload, signatureSecret).toString(
    CryptoJS.enc.Hex
  );
  return hmacSignature;
}

export default Dashboard;
